import { useTranslation } from 'react-i18next'

import { FormikField } from '../../../../Formik'
import { TaskTypeInput } from '../../../TaskTypeInput'
import { TASK_FORM_TYPE_FIELD_NAME } from '../../TaskForm.constants'

import { TYPE_FIELD_VISIBLE_COUNT_ITEMS } from './TypeField.constants'

function TypeField({ isFullScreen, isLoading, items }) {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={TaskTypeInput}
      fieldComponentProps={{
        isLoading,
        label: `${t('Task.FormTypeFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      items={items}
      name={TASK_FORM_TYPE_FIELD_NAME}
      visibleCount={
        isFullScreen ? items.length : TYPE_FIELD_VISIBLE_COUNT_ITEMS
      }
    />
  )
}

export default TypeField
